import { useCollectionData } from 'react-firebase-hooks/firestore';
import firebase from 'firebase';
import { useCallback, useEffect, useState } from 'react';
import { convertDateToFirestoreTimestamp } from '../../firebase/api/firestoreUtils';
import { nanoid } from 'nanoid';
import { useAuth } from '../../hooks/useAuth';

const REPLIES_COLLECTION_NAME = 'replies';
const REPLIES_PAGE_LENGTH = 5;

const buildQuery = (reviewId, lastPageItem = null, limit = null) => {
    let query = firebase
        .firestore()
        .collection(REPLIES_COLLECTION_NAME)
        .where('reviewId', '==', reviewId);
    // .orderBy('createdTimestamp');

    if (lastPageItem) {
        query = query.startAfter(lastPageItem.createdAt);
    }

    if (limit) {
        query = query.limit(REPLIES_PAGE_LENGTH);
    }

    return query;
};

const firebaseOptions = {
    idField: 'uid',
};

export const useReplies = reviewId => {
    const { currentUser } = useAuth();
    const [lastPageItem, setLastPageItem] = useState(null);
    const [replies, setReplies] = useState([]);
    const [count, setCount] = useState(0);
    const [repliesPage, isLoading] = useCollectionData(
        buildQuery(reviewId, lastPageItem),
        firebaseOptions
    );
    // const [repliesSnapshot] = useCollection(buildQuery(reviewId));

    useEffect(() => {
        if (!isLoading && repliesPage) {
            setReplies([...replies, ...repliesPage]);
        }
        // only new page
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    // useEffect(() => {
    //     if (repliesSnapshot) {
    //         setCount(repliesSnapshot.size);
    //     }
    // }, [repliesSnapshot]);

    const loadMore = useCallback(() => {
        setLastPageItem(repliesPage[repliesPage.length - 1]);
    }, [repliesPage]);

    const addReply = useCallback(
        async (reviewId, text) => {
            const db = firebase.firestore();
            const newReply = {
                createdTimestamp: convertDateToFirestoreTimestamp(new Date()),
                createdBy: {
                    firstName: currentUser.firstName,
                    position: currentUser.position,
                    earned: currentUser.earned,
                },
                uid: nanoid(),
                reviewId,
                text,
            };

            await db.collection(REPLIES_COLLECTION_NAME).add(newReply);

            setReplies([...replies, newReply]);
            setCount(count + 1);
        },
        [currentUser, replies, count]
    );

    return {
        replies,
        addReply,
        loadMore,
        count: replies.length,
    };
};
